import {addSpinner, removeSpinner} from '../utilities/spinner.js';

function NewsletterForm ( formEl, formId ) {
  this.form = formEl;
  this.formId = formId;

  this.inputs = this.form.elements;
  this.name = this.inputs['newsletter-name'];
  this.email = this.inputs['newsletter-email'];
  this.company = this.inputs['newsletter-company'];
  this.jobTitle = this.inputs['newsletter-job-title'];
  this.submitButton = this.inputs['submit-newsletter'];

  this.messageContainer = null;
  this.setMessageContainer();

  this.form.addEventListener( 'submit', e => { this.formSubmit( e ) } );
}

NewsletterForm.prototype.formSubmit = function ( e ) {
  e.preventDefault();
  this.submitButton.disabled = true;

  addSpinner( this.messageContainer );
  this.form.classList.add('submitting');

  let postObject = {
    formid: this.formId,
    name: this.name.value,
    email: this.email.value,
    company: this.company.value,
    jobtitle: this.jobTitle.value,
    source: 'newsletter-form'
  }

  console.log(postObject);

  let base_url = `${window.location.protocol}//${window.location.hostname}`;

  if( parseInt(window.location.port, 10) > 0 ){
    base_url = `${base_url}:${window.location.port}`;
  }

  fetch(
    `${base_url}/form-submission-handler`,
    {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'data': postObject
      })
    }).then( response => {
      if( !response.ok ){
        return Promise.reject(new Error(response.statusText))
      } else {
        return Promise.resolve(response)
      }
    }).then( response => {
      console.info(response)
      removeSpinner( this.messageContainer );
      let thankYouText = document.createTextNode('Thank you for your submission!')
      this.messageContainer.appendChild( thankYouText );
      return true;
    })
    .catch( err => {
      console.log( err );
    })
};


NewsletterForm.prototype.setMessageContainer = function () {
  let children = this.form.children;

  [...children].forEach( function( child ){
    if( child.classList.contains('message-container') ){
      this.messageContainer = child;
    }
  }.bind(this))
};


export default NewsletterForm;
